"use strict";

define('evisions/pipe',['vertebrae', 'rs/helper'], function (Vertebrae, helper) {
  var Pipe = Vertebrae.Object.extend({
    properties: ['childAppController', 'childWindow', 'childContentController', 'parentWindow'],
    initialize: function initialize(parentWindow, childWindow) {
      this.setParentWindow(parentWindow);
      this.setChildWindow(childWindow);
    },
    sendMessage: function sendMessage(name, message) {
      if (window == this.getParentWindow()) {
        this._triggerPipeMessageOnWindow(this.getChildWindow(), name, message);
      } else {
        this._triggerPipeMessageOnWindow(this.getParentWindow(), name, message);
      }
    },
    _triggerPipeMessageOnWindow: function _triggerPipeMessageOnWindow(window, name, message) {
      this.constructor.trigger(window, name, message);
    }
  }, {
    create: function create(parentWindow, childWindow) {
      var d = Promise.defer(),
        pipe = new this(parentWindow, childWindow),
        load = null;
      load = function load() {
        childWindow._pipeList = childWindow._pipeList || (childWindow._pipeList = []);
        childWindow._pipeList.push(pipe);
        pipe.once('load', function (appController) {
          pipe.setChildAppController(appController);
          appController.once('content-controller-init', function (contentController) {
            pipe.setChildContentController(contentController);
            d.resolve(pipe);
          });
        });
      };
      load();
      return d.promise;
    },
    trigger: function trigger(win, name, message) {
      var d = $(win.document);
      d.trigger('pipe:', name, message);
    }
  });
  return Pipe;
});

